import { combineReducers } from "redux";
import tableReducer from "./tableReducer";
import ViewerReducer from "./viewerReducer";
import userReducer from "./userReducer";
import statisticsFiltersReducer from "./statisticsFiltersReducer";
import statisticsTableReducer from "./statisticsTableReducer";
import currentProjectReducer from "./currentProjectReducer";
const rootReducer = combineReducers({
  viewer: ViewerReducer,
  table: tableReducer,
  user: userReducer,
  currentProject: currentProjectReducer,
  statisticsFilters : statisticsFiltersReducer,
  statisticsTable : statisticsTableReducer,
});

export default rootReducer;
